
<div class='row no-gutters main-container' (click)='messageClicked()'>

    <!-- <div class="col-2 checkbox-container">
        <mat-checkbox></mat-checkbox> 
    </div> -->
    <div class="col-8 title-content-container">
        <div id='title'> {{messageTitle?.title || 'No title'}} </div>
        <div id='content'> {{messageTitle?.miniContent +'...' }} </div>
    </div>
    <div id='date' class="col-4 date-container">{{messageTitle?.date || 'No date'}}</div>
   
</div>